<template>
  <div class="card border-0 rounded-0">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Détails commandes four.</h3>
      <router-link to="/bons-commandefournisseurs/liste-commandefournisseurs"
        class="btn btn-primary transition border-0 lh-1 fw-medium" style="position: absolute; right: 10px; top: 10px;">
        <i class="flaticon-left-arrow lh-1 me-1"></i>
        Retour
      </router-link>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between"></div>
      <div class="row">
        <!-- Bloc des informations générales -->
        <div class="col-md-8 col-xxl-8 col-sm-12 p-0">
          <h4 class="text-black fw-bold mb-10">Informations commande four.</h4>
          <table class="table">
            <tbody>
              <tr>
                <td>Date Com Four.</td>
                <td>{{ format_date(commandefournisseur?.dateOperation) }} </td>
              </tr>
              <tr>
                <td>Référence Doc</td>
                <td>{{ commandefournisseur?.refDoc }} </td>
              </tr>
              <tr>
                <td>Type Opération</td>
                <td>{{ commandefournisseur?.typeOperation }}</td>
              </tr>
              <!--<tr>
                <td>Motif Suivi</td>
                <td>
                  {{ commandefournisseur?.motifSuivi?.libelle }}
                </td>
              </tr>-->
              <tr>
                <td>Fournisseur</td>
                <td>
                  {{ getFournisseurName(commandefournisseur?.fournisseur) }}
                </td>
              </tr>

            </tbody>
          </table>

          <!-- Tableau des produits -->
          <div class="row">
            <div class="col">
              <h5 class="text-black fw-bold mt-4">Les produits du bon de commande</h5>
            </div>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>Produit</th>
                <th>Qté Com.</th>
                <th>Reste à livrer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(produitcondibon, index) in commandefournisseur?.produitcondibons" :key="index">
                <td>{{ produitcondibon.nomProd.split("|")[1] }} {{ produitcondibon.nomProd.split("|")[2] }}</td>
                <td>{{ separateur(produitcondibon.qteBon) }} {{ produitcondibon.uniteMesure }}</td>
                <td>{{ separateur(produitcondibon.resteAliv) }} {{ produitcondibon.uniteMesure }}</td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="col-md-4 col-xxl-4 col-sm-12 p-0">
          <h5 class="text-black fw-bold mb-10">Image du Bon</h5>

          <hr> <!-- Petit trait séparateur -->
          <img v-if="commandefournisseur?.imageBon" :src="getUrlApiForProductFiles(commandefournisseur?.imageBon)"
            class="d-block w-100" alt="Photo">
        </div>

      </div>
    </div>
  </div>

  <!-- Bloc des images du commandefournisseur avec un slider -->

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { BonLivraison } from "@/models/BonLivraison"; 
import { error, getUrlApiForProductFiles, format_date, suppression,separateur } from "@/utils/utils";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "ViewBonCommandeFournisseur",
  setup() {
    const route = useRoute();
    const commandefournisseur = ref<BonLivraison | null>(null); // À ajuster si vous avez un modèle spécifique
    const medias = ref([]);
    const produitcondibons = ref([]);

    async function getBonLivraison(id: string) {
      try {
        const { data } = await ApiService.get(`/boncomfournisseurs/${id}`);
        console.log(data);
        if (data && data.data) {
          commandefournisseur.value = data.data;
          console.log("Produitcondibons :",);
          medias.value = data.data.medias; // Récupération des médias du commandefournisseur
        } else {
          throw new Error("Données du bon de commandes fournisseurs non trouvées.");
        }
      } catch (err) {
        error(err instanceof Error ? err.message : "Erreur lors de la récupération du commandefournisseur.");
      }
    }

    // Fonction pour déterminer le nom du fournisseur à afficher
    const getFournisseurName = (fournisseur: any) => {
      if (!fournisseur) return "Fournisseur non spécifié";

      // Si denomination existe et n’est pas vide, afficher la raison sociale
      if (fournisseur.denomination && fournisseur.denomination.trim() !== "") {
        return fournisseur.denomination;
      }
      // Sinon, afficher nom et prénom si disponibles
      const nom = fournisseur.nomFournisseur || "";
      const prenom = fournisseur.prenomFournisseur || "";
      return `${nom} ${prenom}`.trim() || "Fournisseur non spécifié";
    };

    onMounted(() => {
      const id = route.params.id as string;
      if (id) {
        getBonLivraison(id);
      } else {
        error("ID du commandefournisseur non spécifié.");
      }
    });

    return {
      commandefournisseur,
      produitcondibons,
      medias,
      suppression,
      format_date,separateur,
      getUrlApiForProductFiles,
      getFournisseurName, // Ajouter la fonction au retour
    };
  },
});
</script>

<style scoped>
.card {
  border: none;
  /* Retire la bordure */
  margin: 0;
  /* Enlève toutes les marges */
}

.card-body {
  padding: 15px;
  /* Ajustez le padding pour vos besoins */
}

/* Enlève la marge entre les colonnes */
.row {
  margin: 0;
  /* Retire l'espacement de la rangée */
}

/* Ajout d'un petit espacement seulement avec un trait séparateur */
.table {
  border-collapse: collapse;
}

.table td {
  padding: 8px;
}

.carousel-inner img {
  max-height: 400px;
  object-fit: cover;
}
</style>
